import { types } from 'mobx-state-tree';
import OrderLine from './OrderLine';

export default types.model('ProductList', {
    OrderLines: types.optional(types.array(OrderLine), []),
    GroupKey: types.string,
    GroupDisplayName: types.string,
    //SubTotalFormatted: types.string,
    //TotalFormatted: types.string,
    DiscountTotalFormatted: types.optional(types.string,""),
    TotalPricesFormatted: types.optional(types.string,""),
	Quantity: types.number,
	//QuantityNA: types.number,
	Edit: types.optional(types.boolean, false)

}).views(self => ({
	get Order() {
		return getParent(self, 2);
	},

})).actions(self => ({
}));
